import { render } from "./import_hmc.vue?vue&type=template&id=20f56bad&scoped=true"
import script from "./import_hmc.vue?vue&type=script&lang=js"
export * from "./import_hmc.vue?vue&type=script&lang=js"

import "./import_hmc.vue?vue&type=style&index=0&id=20f56bad&scoped=true&lang=css"

import exportComponent from "E:\\daxiang\\code\\dx_project_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20f56bad"]])

export default __exports__